import { doGet, doPost, createUrlQueryParams, myFetch, handleResp } from 'src/api/client';

export async function reqGetCurrentBuild() {
  try {
    const response = await fetch('/version.json', { cache: 'no-store' });
    const json = await response.json();
    return json.build;
  } catch (error) {
    console.error('Error checking for updates:', error);
    return null;
  }
}

export async function reqGetProxy(targetURL: string): Promise<string> {
  // Must match backend `/rssproxy/` (trailing slash); keep 15s timeout for slow upstream RSS.
  const path = `rssproxy/?${createUrlQueryParams({ url: targetURL })}`;
  const body = await handleResp(
    await myFetch(path, {
      method: 'GET',
      signal: AbortSignal.timeout(15000)
    })
  );
  if (typeof body !== 'string') {
    throw new Error('RSS proxy returned a non-text response');
  }
  return body;
}

export async function reqGetBenchmarkRanking() {
  return doGet(`get_benchmark_rank`);
}

export async function reqSubmitBenchmarkingEntry(data) {
  return doPost(`submit_benchmark_entry`, data);
}
